import React, { useEffect, useState } from 'react';
import { StyledWidgets, Wrapper, NotificationAlertWrapper, LeftWrapper, RightWrapper, MobileViewWrapper, ToastMessage } from '@app.styled';
import { Notifications, WidgetTemplate, DashboardProps, ToastType } from '../types';
import { useDispatch, useSelector } from 'react-redux';
import { NotificationCard } from '@components/NotificationCard/NotificationCard';
import { selectNotificationsFilterData } from '@store/selectors/alerts.selectors';
import {
    selectOddRankWidgets,
    selectEvenRankWidgets,
    selectEligibleForEscrowScheduled,
    selectCashOutResponse,
    selectIsLoanInProgress
} from '@store/selectors/widgets.selectors';
import CardContainer from './CardContainer';
import { filterAlertsifEscrowScheduledExsists, getSortedOfferCardsByTeaserOffer } from '@utils/filterWidgets';
import { broadcastCashOutResponse, updateWidgetOfferCards } from '@store/actions/widgets.actions';
import { Toast } from 'shared-ui-components';
import { fetchLIPTileAsync } from '@store/actions/lipTile.action';

const DashboardContainer: React.FunctionComponent<DashboardProps> = ({ loanNumber, getOption, cards, updateLoanType }) => {
    const dispatch = useDispatch();

    const alertsData: Notifications[] = useSelector(selectNotificationsFilterData);
    const escrowScheduled: WidgetTemplate = useSelector(selectEligibleForEscrowScheduled);
    const oddRankWidgets: WidgetTemplate[] = useSelector(selectOddRankWidgets);
    const evenRankWidgets: WidgetTemplate[] = useSelector(selectEvenRankWidgets);
    const [showCashOutToaster, setShowCashOutToaster] = useState(false);
    const cashOutResponse: any = useSelector(selectCashOutResponse);
    const selectLoanInProgress = useSelector(selectIsLoanInProgress);
    const filteredAlerts = filterAlertsifEscrowScheduledExsists(escrowScheduled, alertsData, loanNumber);
    const [windowWidth, setWindowWidth] = useState(0);
    const hanldeWindowResize = () => {
        setWindowWidth(window.innerWidth);
    };
    useEffect(() => {
        if (window.innerWidth <= 700) {
            const sortedCards = getSortedOfferCardsByTeaserOffer(cards, loanNumber);
            dispatch(updateWidgetOfferCards(sortedCards));
        }
    }, [loanNumber, window]);
    useEffect(() => {
        window.addEventListener('resize', hanldeWindowResize);
        hanldeWindowResize();
        return () => window.removeEventListener('resize', hanldeWindowResize);
    }, []);
    useEffect(() => {
        if (cashOutResponse?.message != undefined) {
            setShowCashOutToaster(true);

            setTimeout(() => {
                setShowCashOutToaster(false);
                dispatch(broadcastCashOutResponse({}));
            }, 8000);
        }
    }, [cashOutResponse]);
    useEffect(() => {
        window.scrollTo(0, 0);
    });

    useEffect(() => {
        if (selectLoanInProgress) {
            dispatch(fetchLIPTileAsync.cancel()); // This is for reset the LIP Tile Response from redux store.
            selectLoanInProgress?.map((data: any) => {
                dispatch(fetchLIPTileAsync.request(data.identifier));
            });
        }
    }, [selectLoanInProgress]);

    return (
        <StyledWidgets>
            {showCashOutToaster && (
                <ToastMessage>
                    <Toast
                        message={cashOutResponse?.message}
                        toastType={cashOutResponse?.toastType === 'ERROR' ? ToastType.ERROR : ToastType.SUCCESS}
                    />
                </ToastMessage>
            )}
            <NotificationAlertWrapper>
                {Array.isArray(filteredAlerts) &&
                    filteredAlerts.map(alert => <NotificationCard key={alert.notificationId} alertData={alert} />)}
            </NotificationAlertWrapper>
            {windowWidth <= 700 ? (
                <MobileViewWrapper>
                    <>
                        {Array.isArray(cards) &&
                            cards.map(card => (
                                // eslint-disable-next-line react/jsx-key
                                <CardContainer
                                    key={card.id}
                                    card={card}
                                    loanNumber={loanNumber}
                                    getOption={getOption}
                                    updateLoanType={updateLoanType}
                                />
                            ))}
                    </>
                </MobileViewWrapper>
            ) : (
                <Wrapper>
                    <LeftWrapper>
                        {Array.isArray(oddRankWidgets) &&
                            oddRankWidgets.map(card => (
                                // eslint-disable-next-line react/jsx-key
                                <CardContainer
                                    key={card.id}
                                    card={card}
                                    loanNumber={loanNumber}
                                    getOption={getOption}
                                    updateLoanType={updateLoanType}
                                />
                            ))}
                    </LeftWrapper>
                    <RightWrapper>
                        {Array.isArray(evenRankWidgets) &&
                            evenRankWidgets.map(card => (
                                // eslint-disable-next-line react/jsx-key
                                <CardContainer
                                    key={card.id}
                                    card={card}
                                    loanNumber={loanNumber}
                                    getOption={getOption}
                                    updateLoanType={updateLoanType}
                                />
                            ))}
                    </RightWrapper>
                </Wrapper>
            )}
        </StyledWidgets>
    );
};

export default React.memo(DashboardContainer);
